import { Field } from 'react-final-form';
import Radio from 'components/other/Radio';
import Icon from 'components/other/Icons';

import styles from './TestForm.module.scss';

const SubscriptionRightsAmountField = field => (
  <div className={styles.FieldContainer} tabIndex="0">
    <p>Antall handler siste 12 mnd i tegningsretter:</p>
    <Field name="subscriptionRightsAmount" type="radio" value="none">
      {({ input }) => (
        <label htmlFor="subscriptionRightsAmount_none">
          <Radio
            id="subscriptionRightsAmount_none"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Ingen
        </label>
      )}
    </Field>
    <Field name="subscriptionRightsAmount" type="radio" value="lessThan10">
      {({ input }) => (
        <label htmlFor="subscriptionRightsAmount_lessThan10">
          <Radio
            id="subscriptionRightsAmount_lessThan10"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Færre enn 10
        </label>
      )}
    </Field>
    <Field name="subscriptionRightsAmount" type="radio" value="moreThan10">
      {({ input }) => (
        <label htmlFor="subscriptionRightsAmount_moreThan10">
          <Radio
            id="subscriptionRightsAmount_moreThan10"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Flere enn 10
        </label>
      )}
    </Field>
    {field.meta.error && field.meta.touched && (
      <div className={styles.errorContainer}>
        <Icon icon="exclamation-triangle" />
        <span>{field.meta.error}</span>
      </div>
    )}
  </div>
);

export default SubscriptionRightsAmountField;
